import { Colors, DropdownListItem, FInter, FlexBox, Fonts, MEDIA } from "@brg/ui";
import { LayoutConst } from "core";
import ResizedImageEnhanced from "shared/components/ResizedImageEnhanced";
import { ProjectCardTitle } from "shared/components/projectCard/styles";
import { ProjectCardContainerNew } from "shared/components/projectCard/stylesNew";
import styled, { css, keyframes } from "styled-components";
import { Skeleton } from "@brg/ui"
import { DesignerMultipleAuthors } from "shared/components/projectDesignerName/styles";

export const DropdownWrapper = styled.div`
    max-width: 180px;
    z-index: 9999;

    ${DropdownListItem} {
        display: flex;
        flex-flow: row;
        justify-content: space-between;
    }
`;



export const EmblemImgContainer = styled(FlexBox)<{ imgShowed?: boolean, isSuperPuper?: boolean }>`
    ${Fonts.Inter.smallText};
    color: ${Colors.galBlack61};
    background: ${(p) => p.theme.projectEdit.imgContainerBg};
    // background: transparent;
    position: relative;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    user-select: none;
    border-radius: 8px;
    font-size: 17px;
    line-height: 22px;
    letter-spacing: -0.02em;
    width: 270px;
    min-width: 270px;
    height: 380px;
    max-height: 380px;
    max-width: 270px;
    margin: 0px 0 0 24px;

    .empty-holder {
      width: 100%;
    }

    @media(max-width: ${LayoutConst.screen.l}px) {
      margin-top: 0;
      width: calc(166px * 2 + 16px);
      max-width: calc(166px * 2 + 16px);
      min-width: calc(166px * 2 + 16px);
              height: auto;
        max-height: max-content;
    }

    @media (max-width: ${LayoutConst.screen.md}px) {
      margin-bottom: 24px;
    }

    @media (max-width: 992px) {
        margin-left: 16px;
        min-width: ${(LayoutConst.projectCard.xs.w * 2) + LayoutConst.projectCardGap.tablet}px;
        width: ${(LayoutConst.projectCard.xs.w * 2) + LayoutConst.projectCardGap.tablet}px;
        max-width: ${(LayoutConst.projectCard.xs.w * 2) + LayoutConst.projectCardGap.tablet}px;
        height: 489px;
        max-height: 489px;
      //width: 166px;
      //height: 235px;
        align-items: center;
        justify-content: center;
        margin-bottom: 0;
    }

    @media(max-width: 576px) {
      margin-left: 0;
      width: 100%;
      max-width: 100%;
    }

    .team-actions-dots {
      opacity: 0;
      pointer-events: none;
      transition: opacity 0.2s ease;
    }

    &:hover .team-actions-dots,
    &:focus-within .team-actions-dots {
      opacity: 1;
      pointer-events: auto;
    }

    @media (max-width: ${LayoutConst.screen.l}px) {
      .team-actions-dots {
        opacity: 1;
        pointer-events: auto;
      }
    }

    ${({ isSuperPuper }) => isSuperPuper && css`
        @media (max-width: ${LayoutConst.screen.m}px) {
          top: -150px !important;
          margin-bottom: -150px;
        }
    `}
      
`;

export const WideContainer = styled(FlexBox)<{ isLoading?: boolean }>`
  position: relative;
  margin-top: 16px;
  margin-bottom: 24px;
  // cursor: pointer;
  width: 100%;

  img {
    object-fit: cover;
    width: 100%;
    height: 100%;
  }

  width: ${LayoutConst.container.l}px;
  max-width: ${LayoutConst.container.l}px;
  min-width: ${LayoutConst.container.l}px;
  height: auto;

    @media (max-width: ${LayoutConst.screen.l_12}px) {
      width: ${LayoutConst.container.m}px;
      max-width: ${LayoutConst.container.m}px;
      min-width: ${LayoutConst.container.m}px;
    }

    @media (max-width: ${LayoutConst.screen.m}px) {
      // max-height: 234px;
      width: ${LayoutConst.container.xs}px;
      max-width: ${LayoutConst.container.xs}px;
      min-width: ${LayoutConst.container.xs}px;
    }

    @media (max-width: ${LayoutConst.screen.s - 1}px) {
      width: 100%;
      max-width: 100%;
      min-width: 100%;
      margin-top: 0;
    }
`;

export const CoverImage = styled(ResizedImageEnhanced)<{ isSquare?: boolean }>`
  position: absolute;
  flex-shrink: 0;
  top: 0;
  left: 0;
  height: ${({ isSquare }) => isSquare ? 'initial' : '100%'};
`;

export const TitleBox = styled(FlexBox)`
  position: absolute;
  z-index: 2;
  flex-flow: column;
  bottom: 24px;
  background-color: #f2f2f2;
  min-height: 116px;
  padding: 16px 24px;
  left: 0;
  width: ${(LayoutConst.projectCard.l.w * 2) + LayoutConst.projectCardGap.l}px;
  max-width: ${(LayoutConst.projectCard.l.w * 2) + LayoutConst.projectCardGap.l}px;
  min-width: ${(LayoutConst.projectCard.l.w * 2) + LayoutConst.projectCardGap.l}px;
  justify-content: space-between;

  .multiple-authors {
    :hover {
      color: #151514;
    }
  }

  ${DesignerMultipleAuthors} {
    :hover {
      .item {
        z-index: 99999;
      }

      color: #151514;
      .multiple-authors {
        color: #151514;
      }
      svg path {
        fill: #151514;
      }
    }
  }

  @media (max-width: ${LayoutConst.screen.s - 1}px) {
    bottom: 0;
    left: 0;
    width: 100%;
    max-width: 100%;
    min-width: 100%;
    min-height: 82px;
  }
`;


export const Title = styled(ProjectCardTitle)`
  font-size: 22px;
  line-height: 28px;
  color: ${({ theme }) => theme.wideCover.info.title.color};

  @media (max-width: ${LayoutConst.screen.m}px) {
    font-size: 17px;
    line-height: 22px;
  }

`;

export const Author = styled(FlexBox)`
  color: ${({ theme }) => theme.wideCover.info.author.color};
  font-size: 13px;
  line-height: 16px;
`;

export const ImageCover = styled(FlexBox)`
  margin: 0 auto;
  width: 534px;
  height: 240px;

  @media (max-width: ${LayoutConst.screen.mac13}px), (max-height: ${LayoutConst.screen.height.projectCover}px) {
    width: 355px;
    height: 160px;
  }

  @media (max-width: ${LayoutConst.screen.s -1}px) {
    max-width: 320px;
    height: auto;
  }
`;


export const LettersAvatarWrapper = styled(FlexBox)`
  width: 100%;
  height: 100%;
  align-items: center;
  justify-content: center;
  font-size: 90px !important;
  color: ${Colors.geoWhite47} !important;
  border-radius: initial;
`;

export const TeamTabsWrapper = styled(FlexBox)`
  @media (max-width: ${LayoutConst.screen.s - 1}px) {
    overflow-x: auto;
    overflow-y: visible;
    padding-bottom: 4px;
    box-sizing: border-box;
    ::-webkit-scrollbar {
      height: 2px;
      display: none;
    }
    ::-webkit-scrollbar-thumb {
      background: transparent;
      visibility: hidden;
      
    }
    ::-webkit-scrollbar-track {
      background: transparent !important;
    }
  }
  
  &:empty {
    display: none;
  }
`;

export const ChannelNamContainer = styled.div<{ bg: string }>`
  position: relative;
  width: 100%;
  height: 100%;
  flex-flow: column;
  display: flex;
  padding: 24px;
  background-color: ${({ bg }) => bg ? bg : '#909090'};

  .course-lms_type {
    font-family: 'Inter';
    font-weight: 400;
    font-size: 13px;
    line-height: 16px;
    letter-spacing: -0.26px;
    margin-bottom: 4px;
    color: #fff;
  }

  .course-type {
    font-family: 'Inter';
    font-weight: 400;
    font-size: 13px;
    line-height: 16px;
    letter-spacing: -0.26px;
    margin-bottom: 10px;
    color: #fff;
  }

  .course-name {
    font-family: 'Inter';
    font-weight: 600;
    font-size: 22px;
    line-height: 28px;
    letter-spacing: -0.44px;
    color: #fff;
    margin-bottom: 16px;

    @media (max-width: ${LayoutConst.screen.l + 1}px) {
      font-size: 13px;
      line-height: 16px;
      letter-spacing: -0.3px;
    }
  }

`;

export const SubTitleGroupName = styled.div`
   font-family: 'Inter';
    font-weight: 600;
    font-size: 23px;
    line-height: 27px;
    letter-spacing: -2%;
    color: #151514;
    margin-top: 8px;
`;

export const TeamMetaContainer = styled(FlexBox)<{ open?: boolean }>`
  width: 100%;
  flex-flow: column;
  // :empty {
  //   display: none;
  // }
`;

export const TeamMetaSwitcher = styled(FlexBox)<{ open?: boolean }>`
  cursor: pointer;
  position: relative;
  width: 100%;
  margin-top: ${({ open }) => open ? 0 : '14px'};

  span {
    color: ${({ theme }) => theme.teamMeta.color};
    transition: color 0.2s;
    font-size: 17px;
    line-height: 22px;
    font-weight: 600;
  }
  :hover {
    color: ${({ theme }) => theme.teamMeta.hover};
    transition: color 0.2s;
  }

  ${({ open }) => open ? css`
    .team-meta-icon-wrap {
      order: 2;
    }

    .team-meta-devider {
      order: 1;
    }
  ` : css`
    .team-meta-icon-wrap {
      order: 1;
    }

    .team-meta-devider {
      order: 2;
    }
  `};
`;


export const TeamMetaData = styled(FlexBox)<{ open?: boolean, viewType: any }>`
  :empty {
    display: none;
  }
  color: ${({ theme }) => theme.teamMeta.color};
  font-size: 17px;
  line-height: 22px;
  border-top: 1px solid ${Colors.galBlack47};
  margin: 16px 0 0 0;
  padding: ${({open}) => (open? '16px 0' : '0')};
  flex-flow: column;
  display: ${({ open }) => open ? 'flex' : 'none'};

  .data-item {
    display: flex;
    flex-flow: row;
    place-items: center;

    :not(:last-child) {
      margin-bottom: 12px;
    }
  }

  @media ${MEDIA.LAPTOP} {
    font-size: 15px;
    line-height: 20px;
  }

  ${({ viewType }) => ['row', 'feed', 'chat']?.includes(viewType as any) && css`
    border: none;
    flex-flow: row;
    gap: 24px;
    margin: 12px 0 0 0;
    padding: 0;

      .data-item {
        width: min-content;
        max-width: min-content;
        gap: 4px;
        font-weight: 600;

        :not(:last-child) {
          margin-bottom: 0px;
        }
      }
  `};


`;

export const SwitchContainer = styled(FlexBox)<{open?: boolean}>`
  align-items: center;
  position: relative;
  width: 100%;
  white-space: nowrap;
  gap: 24px;
  svg {
    transform: rotate(${({open}) => open  ? '0deg' : '-180deg'});
    transition: transform 0.2s;
  }
  :hover {
    span, svg path {
      color: ${({ theme }) => theme.teamMeta.hover};
      fill: ${({ theme }) => theme.teamMeta.hover};
      transition: all 0.2s;
    }
  }

`;

export const TeamMetaLabel = styled.div<{viewType?: any }>`
  font-family: 'Inter';
  color: ${({ theme }) => theme.teamMeta.color};
  font-size: 17px;
  line-height: 22px;
  white-space: nowrap;
  letter-spacing: -0.02em;
  min-width: ${({ viewType }) => ['row', 'feed', 'chat']?.includes(viewType as any) ? 'min-content' : '188px'};
`;

export const TeamMetaName= styled.div`
  font-family: 'Inter';
  color: ${({ theme }) => theme.teamMeta.color};
  font-size: 17px;
  line-height: 22px;
  white-space: pre-wrap;
  font-weight: 600;
  letter-spacing: -0.02em;

  @media (max-width: ${LayoutConst.screen.m}px) {
    font-size: 15px;
    line-height: 20px;
  }
`;

export const TeamMetaDevider = styled.div.attrs({
  className: 'team-meta-devider'
})`
  width: 100%;
  border-top: 1px solid ${({ theme }) => theme.teamMeta.color};
`;

export const WorkMediiiaInfoBlockContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  background-color: ${Colors.geoWhite100};
  padding: 16px;
  box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.12);
  gap: 5px;
  margin-top: 16px;

  * {
    color: ${Colors.galBlack100};
  }
`;

export const WorkMediiiaInfoBlockTitle = styled.div`
  font-family: 'Inter';
  font-weight: 600;
  font-size: 17px;
  line-height: 22px;
  letter-spacing: -0.02em;
`;

export const WorkMediiiaInfoBlockSubtitle = styled.div`
  font-family: 'Inter';
  font-weight: 400;
  font-size: 17px;
  line-height: 22px;
  letter-spacing: -0.02em;
`;

export const mediaShowcaseStylesDisabledOffset = css`
  margin-top: 0px !important;

  .mobile-tabs-box-column {
    margin-top: 0 !important;
  }

  @media${MEDIA.MOBILE} {
    margin-top: 16px !important;
  }
`;

import { Colors, DropdownListItem, FInter, FlexBox, Fonts, MEDIA } from "@brg/ui";
import { LayoutConst } from "core";
import ResizedImageEnhanced from "shared/components/ResizedImageEnhanced";
import { ProjectCardTitle } from "shared/components/projectCard/styles";
import { ProjectCardContainerNew } from "shared/components/projectCard/stylesNew";
import styled, { css, keyframes } from "styled-components";
import { Skeleton } from "@brg/ui"
import { DesignerMultipleAuthors } from "shared/components/projectDesignerName/styles";

export const DropdownWrapper = styled.div`
    max-width: 180px;
    z-index: 9999;

    ${DropdownListItem} {
        display: flex;
        flex-flow: row;
        justify-content: space-between;
    }
`;



export const EmblemImgContainer = styled(FlexBox)<{ imgShowed?: boolean, isSuperPuper?: boolean }>`
    ${Fonts.Inter.smallText};
    color: ${Colors.galBlack61};
    background: ${(p) => p.theme.projectEdit.imgContainerBg};
    // background: transparent;
    position: relative;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    user-select: none;
    border-radius: 8px;
    font-size: 17px;
    line-height: 22px;
    letter-spacing: -0.02em;
    width: 270px;
    min-width: 270px;
    height: 380px;
    max-height: 380px;
    max-width: 270px;
    margin: 0px 0 0 24px;

    .empty-holder {
      width: 100%;
    }

    @media(max-width: ${LayoutConst.screen.l}px) {
      margin-top: 0;
      width: calc(166px * 2 + 16px);
      max-width: calc(166px * 2 + 16px);
      min-width: calc(166px * 2 + 16px);
              height: auto;
        max-height: max-content;
    }

    @media (max-width: ${LayoutConst.screen.md}px) {
      margin-bottom: 24px;
    }

    @media (max-width: 992px) {
        margin-left: 16px;
        min-width: ${(LayoutConst.projectCard.xs.w * 2) + LayoutConst.projectCardGap.tablet}px;
        width: ${(LayoutConst.projectCard.xs.w * 2) + LayoutConst.projectCardGap.tablet}px;
        max-width: ${(LayoutConst.projectCard.xs.w * 2) + LayoutConst.projectCardGap.tablet}px;
        height: 489px;
        max-height: 489px;
      //width: 166px;
      //height: 235px;
        align-items: center;
        justify-content: center;
        margin-bottom: 0;
    }

    @media(max-width: 576px) {
      margin-left: 0;
      width: 100%;
      max-width: 100%;
    }

    .team-actions-dots {
      opacity: 0;
      pointer-events: none;
      transition: opacity 0.2s ease;
    }

    &:hover .team-actions-dots,
    &:focus-within .team-actions-dots {
      opacity: 1;
      pointer-events: auto;
    }

    @media (max-width: ${LayoutConst.screen.l}px) {
      .team-actions-dots {
        opacity: 1;
        pointer-events: auto;
      }
    }

    ${({ isSuperPuper }) => isSuperPuper && css`
        @media (max-width: ${LayoutConst.screen.m}px) {
          top: -150px !important;
          margin-bottom: -150px;
        }
    `}
      
`;

export const WideContainer = styled(FlexBox)<{ isLoading?: boolean }>`
  position: relative;
  margin-top: 16px;
  margin-bottom: 24px;
  // cursor: pointer;
  width: 100%;

  img {
    object-fit: cover;
    width: 100%;
    height: 100%;
  }

  width: ${LayoutConst.container.l}px;
  max-width: ${LayoutConst.container.l}px;
  min-width: ${LayoutConst.container.l}px;
  height: auto;

    @media (max-width: ${LayoutConst.screen.l_12}px) {
      width: ${LayoutConst.container.m}px;
      max-width: ${LayoutConst.container.m}px;
      min-width: ${LayoutConst.container.m}px;
    }

    @media (max-width: ${LayoutConst.screen.m}px) {
      // max-height: 234px;
      width: ${LayoutConst.container.xs}px;
      max-width: ${LayoutConst.container.xs}px;
      min-width: ${LayoutConst.container.xs}px;
    }

    @media (max-width: ${LayoutConst.screen.s - 1}px) {
      width: 100%;
      max-width: 100%;
      min-width: 100%;
      margin-top: 0;
    }
`;

export const CoverImage = styled(ResizedImageEnhanced)<{ isSquare?: boolean }>`
  position: absolute;
  flex-shrink: 0;
  top: 0;
  left: 0;
  height: ${({ isSquare }) => isSquare ? 'initial' : '100%'};
`;

export const TitleBox = styled(FlexBox)`
  position: absolute;
  z-index: 2;
  flex-flow: column;
  bottom: 24px;
  background-color: #f2f2f2;
  min-height: 116px;
  padding: 16px 24px;
  left: 0;
  width: ${(LayoutConst.projectCard.l.w * 2) + LayoutConst.projectCardGap.l}px;
  max-width: ${(LayoutConst.projectCard.l.w * 2) + LayoutConst.projectCardGap.l}px;
  min-width: ${(LayoutConst.projectCard.l.w * 2) + LayoutConst.projectCardGap.l}px;
  justify-content: space-between;

  .multiple-authors {
    :hover {
      color: #151514;
    }
  }

  ${DesignerMultipleAuthors} {
    :hover {
      .item {
        z-index: 99999;
      }

      color: #151514;
      .multiple-authors {
        color: #151514;
      }
      svg path {
        fill: #151514;
      }
    }
  }

  @media (max-width: ${LayoutConst.screen.s - 1}px) {
    bottom: 0;
    left: 0;
    width: 100%;
    max-width: 100%;
    min-width: 100%;
    min-height: 82px;
  }
`;


export const Title = styled(ProjectCardTitle)`
  font-size: 22px;
  line-height: 28px;
  color: ${({ theme }) => theme.wideCover.info.title.color};

  @media (max-width: ${LayoutConst.screen.m}px) {
    font-size: 17px;
    line-height: 22px;
  }

`;

export const Author = styled(FlexBox)`
  color: ${({ theme }) => theme.wideCover.info.author.color};
  font-size: 13px;
  line-height: 16px;
`;

export const ImageCover = styled(FlexBox)`
  margin: 0 auto;
  width: 534px;
  height: 240px;

  @media (max-width: ${LayoutConst.screen.mac13}px), (max-height: ${LayoutConst.screen.height.projectCover}px) {
    width: 355px;
    height: 160px;
  }

  @media (max-width: ${LayoutConst.screen.s -1}px) {
    max-width: 320px;
    height: auto;
  }
`;


export const LettersAvatarWrapper = styled(FlexBox)`
  width: 100%;
  height: 100%;
  align-items: center;
  justify-content: center;
  font-size: 90px !important;
  color: ${Colors.geoWhite47} !important;
  border-radius: initial;
`;

export const TeamTabsWrapper = styled(FlexBox)`
  @media (max-width: ${LayoutConst.screen.s - 1}px) {
    overflow-x: auto;
    overflow-y: visible;
    padding-bottom: 4px;
    box-sizing: border-box;
    ::-webkit-scrollbar {
      height: 2px;
      display: none;
    }
    ::-webkit-scrollbar-thumb {
      background: transparent;
      visibility: hidden;
      
    }
    ::-webkit-scrollbar-track {
      background: transparent !important;
    }
  }
  
  &:empty {
    display: none;
  }
`;

export const ChannelNamContainer = styled.div<{ bg: string }>`
  position: relative;
  width: 100%;
  height: 100%;
  flex-flow: column;
  display: flex;
  padding: 24px;
  background-color: ${({ bg }) => bg ? bg : '#909090'};

  .course-lms_type {
    font-family: 'Inter';
    font-weight: 400;
    font-size: 13px;
    line-height: 16px;
    letter-spacing: -0.26px;
    margin-bottom: 4px;
    color: #fff;
  }

  .course-type {
    font-family: 'Inter';
    font-weight: 400;
    font-size: 13px;
    line-height: 16px;
    letter-spacing: -0.26px;
    margin-bottom: 10px;
    color: #fff;
  }

  .course-name {
    font-family: 'Inter';
    font-weight: 600;
    font-size: 22px;
    line-height: 28px;
    letter-spacing: -0.44px;
    color: #fff;
    margin-bottom: 16px;

    @media (max-width: ${LayoutConst.screen.l + 1}px) {
      font-size: 13px;
      line-height: 16px;
      letter-spacing: -0.3px;
    }
  }

`;

export const SubTitleGroupName = styled.div`
   font-family: 'Inter';
    font-weight: 600;
    font-size: 23px;
    line-height: 27px;
    letter-spacing: -2%;
    color: #151514;
    margin-top: 8px;
`;

export const TeamMetaContainer = styled(FlexBox)<{ open?: boolean }>`
  width: 100%;
  flex-flow: column;
  // :empty {
  //   display: none;
  // }
`;

export const TeamMetaSwitcher = styled(FlexBox)<{ open?: boolean }>`
  cursor: pointer;
  position: relative;
  width: 100%;
  margin-top: ${({ open }) => open ? 0 : '14px'};

  span {
    color: ${({ theme }) => theme.teamMeta.color};
    transition: color 0.2s;
    font-size: 17px;
    line-height: 22px;
    font-weight: 600;
  }
  :hover {
    color: ${({ theme }) => theme.teamMeta.hover};
    transition: color 0.2s;
  }

  ${({ open }) => open ? css`
    .team-meta-icon-wrap {
      order: 2;
    }

    .team-meta-devider {
      order: 1;
    }
  ` : css`
    .team-meta-icon-wrap {
      order: 1;
    }

    .team-meta-devider {
      order: 2;
    }
  `};
`;


export const TeamMetaData = styled(FlexBox)<{ open?: boolean, viewType: any }>`
  :empty {
    display: none;
  }
  color: ${({ theme }) => theme.teamMeta.color};
  font-size: 17px;
  line-height: 22px;
  border-top: 1px solid ${Colors.galBlack47};
  margin: 16px 0 0 0;
  padding: ${({open}) => (open? '16px 0' : '0')};
  flex-flow: column;
  display: ${({ open }) => open ? 'flex' : 'none'};

  .data-item {
    display: flex;
    flex-flow: row;
    place-items: center;

    :not(:last-child) {
      margin-bottom: 12px;
    }
  }

  @media ${MEDIA.LAPTOP} {
    font-size: 15px;
    line-height: 20px;
  }

  ${({ viewType }) => ['row', 'feed', 'chat']?.includes(viewType as any) && css`
    border: none;
    flex-flow: row;
    gap: 24px;
    margin: 12px 0 0 0;
    padding: 0;

      .data-item {
        width: min-content;
        max-width: min-content;
        gap: 4px;
        font-weight: 600;

        :not(:last-child) {
          margin-bottom: 0px;
        }
      }
  `};


`;

export const SwitchContainer = styled(FlexBox)<{open?: boolean}>`
  align-items: center;
  position: relative;
  width: 100%;
  white-space: nowrap;
  gap: 24px;
  svg {
    transform: rotate(${({open}) => open  ? '0deg' : '-180deg'});
    transition: transform 0.2s;
  }
  :hover {
    span, svg path {
      color: ${({ theme }) => theme.teamMeta.hover};
      fill: ${({ theme }) => theme.teamMeta.hover};
      transition: all 0.2s;
    }
  }

`;

export const TeamMetaLabel = styled.div<{viewType?: any }>`
  font-family: 'Inter';
  color: ${({ theme }) => theme.teamMeta.color};
  font-size: 17px;
  line-height: 22px;
  white-space: nowrap;
  letter-spacing: -0.02em;
  min-width: ${({ viewType }) => ['row', 'feed', 'chat']?.includes(viewType as any) ? 'min-content' : '188px'};
`;

export const TeamMetaName= styled.div`
  font-family: 'Inter';
  color: ${({ theme }) => theme.teamMeta.color};
  font-size: 17px;
  line-height: 22px;
  white-space: pre-wrap;
  font-weight: 600;
  letter-spacing: -0.02em;

  @media (max-width: ${LayoutConst.screen.m}px) {
    font-size: 15px;
    line-height: 20px;
  }
`;

export const TeamMetaDevider = styled.div.attrs({
  className: 'team-meta-devider'
})`
  width: 100%;
  border-top: 1px solid ${({ theme }) => theme.teamMeta.color};
`;

export const WorkMediiiaInfoBlockContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  background-color: ${Colors.geoWhite100};
  padding: 16px;
  box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.12);
  gap: 5px;
  margin-top: 16px;

  * {
    color: ${Colors.galBlack100};
  }
`;

export const WorkMediiiaInfoBlockTitle = styled.div`
  font-family: 'Inter';
  font-weight: 600;
  font-size: 17px;
  line-height: 22px;
  letter-spacing: -0.02em;
`;

export const WorkMediiiaInfoBlockSubtitle = styled.div`
  font-family: 'Inter';
  font-weight: 400;
  font-size: 17px;
  line-height: 22px;
  letter-spacing: -0.02em;
`;

export const mediaShowcaseStylesDisabledOffset = css`
  margin-top: 0px !important;

  .mobile-tabs-box-column {
    margin-top: 0 !important;
  }

  @media${MEDIA.MOBILE} {
    margin-top: 16px !important;
  }
`;

